import React from 'react';
import { Restricted } from 'dyl-components';
import { Error403 } from 'pages';
import { useLocation } from "react-router";

import './index.scss';

const RestrictedView = ({ 
    children, 
    type,
    userPermission = false,
    productPermission = '',
    userRestrict = false,
    assignmentIds,
    accessRole,
    modifiers
}) => { 
   
    const { pathname } = useLocation();
    const pathSplit = pathname?.split("/");
    const isContact = pathSplit[1] === "contact" || pathSplit[1] === "contacts" || pathSplit[1] === "leads" || pathSplit[1] === "opportunities";
    const profileUserId = Number(pathSplit[3]);

    return <Restricted
        children={children} 
        type={type} 
        userPermission={userPermission} 
        productPermission={productPermission}
        userRestrict={userRestrict}
        assignmentIds={assignmentIds}
        profileUserId={profileUserId}
        isContact={isContact}
        error403={<Error403 />}
        accessRole={accessRole}
        modifiers={modifiers}
    />
}
  
export default RestrictedView;

 	